import { Badge } from '@valwin/facto/components';

type RoleBadgeProps = {
  role: 'support' | 'admin';
};

export function RoleBadge({ role }: RoleBadgeProps) {
  return (
    <Badge
      colorPalette={role === 'admin' ? 'red' : 'teal'}
      textTransform="initial"
    >
      {role === 'admin' ? 'Admin' : 'Support'}
    </Badge>
  );
}
